var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"dashboard",staticStyle:{"background-color":"#F0F0F0"},attrs:{"title":"Brugere"}},[_c('button-view',{staticStyle:{"float":"left"},attrs:{"slot":"tools"},on:{"click":_vm.createUser},slot:"tools"},[_vm._v("+ Bruger")]),_c('new-table-view',{staticClass:"list",attrs:{"columns":[
			{
				label: 'Brugernavn',
				name: 'username'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				},
				weight: '100px'
			}
		],"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext,"delete":_vm.itemDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }